// Catálogo ColoresLlamada: el campo `color` de un tipo de llamada (tiposllamada/Listado
// y los servicios de llamadas activas) es independiente de su área de atención, por lo
// que el color del badge nunca debe derivarse del área.
const COLOR_CLASSES = {
    1: 'parosView-table-color1', // Verde
    2: 'parosView-table-color2', // Rojo
    3: 'parosView-table-color3', // Amarillo
    4: 'parosView-table-color4', // Azul
};

export const CLASE_SIN_COLOR = 'parosView-table-areaS';

export const claseColorLlamada = (color) => COLOR_CLASSES[color] ?? null;
